export default "__VITE_ASSET__dxC49rJF__"